import { ReactNode } from 'react';
import AboutUsModule from './AboutUsModule';
import AboutUsSiteContainer from './AboutUsSiteContainer';
import styles from './AboutUsTextModule.module.css';

interface Props {
  children: ReactNode;
}
const AboutUsTextModule = (props: Props) => {
  return (
    <AboutUsModule background="grey">
      <AboutUsSiteContainer>
        {/* We may not always apply bolder styles text in the TextModule in the future, it may need to be a prop.... */}
        <div className={styles.container + ' ' + styles.bolder}>
          {props.children}
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
}
export default AboutUsTextModule;